import React, { FunctionComponent, useCallback, useState } from 'react'
import { connect } from 'react-redux'

import { selectVscProducts } from '../../../reducers'
import {
  updateRefiProducts,
  setRefiAppCreditStepState,
  optinRefiMembership,
} from '../refiActions'
import {
  selectCoverageProducts,
  selectCurrentRefiApplication,
  selectGapProduct,
  selectSelectedGapProduct,
} from '../../../reducers/refis'
import { Callback } from '../../../utils/types'
import { RefiApp } from '../types'
import { Product } from '../../refiTransactions/types'
import ProductsForm from '../productsForm'

interface Props {
  vscProducts: Product[]
  gapProduct: Product
  selectedGapProduct: Product
  updateRefiProducts: Callback<Promise<any>>
  selectedCoverageProducts: { selectedOptions: []; selectedSurcharges: [] }
  refiApp: RefiApp
  setRefiAppCreditStepState: Callback
  optinRefiMembership: Callback
}

export const VscProductsSelection: FunctionComponent<Props> = ({
  vscProducts,
  gapProduct,
  updateRefiProducts,
  selectedCoverageProducts,
  refiApp,
  setRefiAppCreditStepState,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const { selectedSurcharges, selectedOptions } = selectedCoverageProducts

  const handleSubmit = useCallback(
    ({ isDeclineCoverage }) => {
      // if gap was previously selected it needs to make the api calls here - even if
      // vsc is declined - because update deal was skipped
      if (isDeclineCoverage && !gapProduct?.selected_option_id)
        return setRefiAppCreditStepState('ReviewAndConfirm')

      setIsLoading(true)
      const options = selectedOptions.map((o: any) => [o.productId, o.id])
      const updateRefiProductsData = {
        options: [
          ...options,
          ...(gapProduct?.selected_option_id
            ? [[gapProduct.id, gapProduct.selected_option_id]]
            : []),
        ],
        surcharges: selectedSurcharges,
        id: refiApp.refiId,
        user_id: refiApp.userId,
      }
      updateRefiProducts(updateRefiProductsData)
        .then(() => setRefiAppCreditStepState('ReviewAndConfirm'))
        .catch(() => setIsLoading(false))
    },
    [selectedCoverageProducts, vscProducts]
  )

  return (
    <div>
      <div className="coverage__sub-header coverage__sub-header--margin-bottom">
        Available protection products
      </div>
      <ProductsForm
        products={vscProducts}
        onSubmit={handleSubmit}
        selectedCoverageProducts={selectedCoverageProducts}
        submitButtonText="Review Agreement"
        isSubmitBtnLoading={isLoading}
        onClickBack={() => setRefiAppCreditStepState('MembershipAndGapProduct')}
      />
    </div>
  )
}

export const mapStateToProps = (state) => ({
  vscProducts: selectVscProducts(state),
  gapProduct: selectGapProduct(state),
  selectedCoverageProducts: selectCoverageProducts(state),
  refiApp: selectCurrentRefiApplication(state),
  selectedGapProduct: selectSelectedGapProduct(state),
})

export default connect(mapStateToProps, {
  updateRefiProducts,
  setRefiAppCreditStepState,
  optinRefiMembership,
})(VscProductsSelection)
